import graphql__8ee7641f4b9a7df0efd0 from "./__generated__/MapFilter_filter.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import MapFilterTaxonomy from "./MapFilterTaxonomy";
import MapFilterElement from "./MapFilterElement";
import MapFilterUser from "./MapFilterUser";

const MapFilterTypes = {
  MapFilterTaxonomy,
  MapFilterElement,
  MapFilterUser
};

const MapFilter = props => {
  const { filter } = props;
  const typename = filter.__typename;
  const MapFilterType = MapFilterTypes[typename];

  if (!MapFilterType) {
    console.error("MapFilterType does not exist for typename : ", typename);
    return null;
  }

  return <MapFilterType {...props} />;
};

export default createFragmentContainer(MapFilter, {
  filter: graphql__8ee7641f4b9a7df0efd0
});
